<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h3>{{ 'support.header.title' | translate }}</h3>
        <p class="modal-subtitle">{{ 'support.header.subtitle' | translate }}</p>
      </div>
      <button type="button" class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body">
      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="object">{{ 'support.form.objectLabel' | translate }}</label>
          <select id="object" [(ngModel)]="selectedObject" name="object" required>
            <option value="">{{ 'support.form.objectPlaceholder' | translate }}</option>
            <option *ngFor="let obj of objects" [value]="obj.value">{{ obj.label | translate }}</option>
          </select>
        </div>

        <div class="form-group" *ngIf="establishments().length > 0">
          <label for="establishment">{{ 'support.form.establishmentLabel' | translate }}</label>
          <select id="establishment" [(ngModel)]="selectedEstablishment" name="establishment">
            <option value="">{{ 'support.form.allEstablishments' | translate }}</option>
            <option *ngFor="let estab of establishments()" [value]="estab.id">{{ estab.name }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="message">{{ 'support.form.messageLabel' | translate }}</label>
          <textarea
            id="message"
            [(ngModel)]="message"
            name="message"
            rows="6"
            [placeholder]="'support.form.messagePlaceholder' | translate"
            required></textarea>
        </div>

        <div class="modal-actions">
          <button type="button" class="secondary" (click)="onClose()">{{ 'support.form.cancel' | translate }}</button>
          <button type="submit" class="primary" [disabled]="sending()">
            {{ (sending() ? 'support.form.sending' : 'support.form.send') | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>